// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"9b8b21ad","406":"668f46cc","412":"8651ff12","762":"212d9b70","767":"ca4a476d"}[chunkId] + ".chunk.js";
};